/*
 * BXGY auto-add engine (native-discount version).
 *
 * Adds gift lines when their trigger product is in the cart, removes them when
 * the trigger leaves, and RESPECTS a shopper who deletes a gift (it stays gone
 * for the session, until the trigger is removed and re-added). Reads the
 * trigger->gift map from [data-bxgy-gifts] (emitted by bxgy-gift-config.liquid
 * from the gift_rule metaobjects).
 *
 * Pricing is done by the matching native Buy-X-Get-Y automatic discount, NOT
 * here — this only puts the right line in the cart. Each added line carries a
 * `__bxgy_gift` property (= the trigger product id) so two triggers sharing a
 * gift each get their own line and cleanup finds its own lines by key.
 *
 * One cart read (skipped when the cartUpdate event carries a full cart), then a
 * batched write whose re-rendered drawer is painted once — no optimistic DOM to
 * fight the theme's own repaint (which was causing the gift to flash/jump).
 */
(function () {
  'use strict';
  if (window.__bxgyGiftInit) return;
  window.__bxgyGiftInit = true;

  var TAG = '__bxgy_gift';
  var SNAP = 'bxgy:snapshot';   /* "trigger|variant" gift lines present after the last pass */
  var DISMISS = 'bxgy:dismissed'; /* "trigger|variant" the shopper deleted this session */
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SECTIONS = ['cart-drawer'];
  var running = false;
  var queued = false;
  var queuedDismiss = false;

  function readRules() {
    var el = document.querySelector('[data-bxgy-gifts]');
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  }
  function numericPart(gid) { var m = /(\d+)$/.exec(String(gid == null ? '' : gid)); return m ? m[1] : null; }
  function fetchCart() { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function looksLikeFullCart(c) { return c && typeof c.item_count === 'number' && Array.isArray(c.items); }

  /* ---- session state ----------------------------------------------------- */
  function ssGet(k) { try { return JSON.parse(sessionStorage.getItem(k) || '[]'); } catch (e) { return []; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function ssAdd(k, id) { var l = ssGet(k); if (l.indexOf(id) === -1) { l.push(id); ssSet(k, l); } }
  function ssRemove(k, id) { var l = ssGet(k); var i = l.indexOf(id); if (i !== -1) { l.splice(i, 1); ssSet(k, l); } }

  /* ---- cart writes ------------------------------------------------------- */
  function addGifts(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items, sections: SECTIONS })
    }).then(function (res) { return res.ok ? res.json() : null; });
  }
  function removeKeys(keys) {
    var chain = Promise.resolve(null);
    keys.forEach(function (key) {
      chain = chain.then(function (prev) {
        return fetch(root + 'cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0, sections: SECTIONS })
        }).then(function (res) { return res.ok ? res.json() : prev; }).catch(function () { return prev; });
      });
    });
    return chain;
  }
  function drawerHTMLOf(o) { return o && o.sections && o.sections['cart-drawer']; }
  function paintDrawer(html) {
    if (!html) return;
    try {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var fresh = parsed.querySelector('#CartDrawer');
      var live = document.getElementById('CartDrawer');
      var drawer = document.querySelector('cart-drawer');
      if (fresh && live) {
        live.innerHTML = fresh.innerHTML;
        var overlay = live.querySelector('#CartDrawer-Overlay');
        if (overlay && drawer && drawer.close) overlay.addEventListener('click', drawer.close.bind(drawer));
      }
      var freshDrawer = parsed.querySelector('cart-drawer');
      if (drawer && freshDrawer) drawer.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
    } catch (e) { console.warn('[bxgy] paint failed', e); }
  }
  function updateBubble(n) { if (n == null) return; var b = document.querySelector('.cart-count-bubble'); if (b) b.textContent = n; }

  /* ---- reconcile --------------------------------------------------------- */

  function reconcile(seedCart, allowDismiss) {
    if (running) { queued = true; if (allowDismiss) queuedDismiss = true; return; }
    running = true;
    var rules = readRules();
    var read = looksLikeFullCart(seedCart) ? Promise.resolve(seedCart) : fetchCart();
    read.then(function (cart) {
      var triggerProductInCart = {};
      var giftPresent = {};
      for (var i = 0; i < cart.items.length; i++) {
        triggerProductInCart[String(cart.items[i].product_id)] = true;
        var tg = cart.items[i].properties && cart.items[i].properties[TAG];
        if (tg) giftPresent[String(tg) + '|' + String(cart.items[i].variant_id)] = true;
      }

      /* Dismissal: on a shopper cart edit, a gift that was present last pass and
         is now gone while its trigger stays is a deliberate delete — remember it
         so we don't re-add it. Cleared once its trigger leaves the cart. */
      if (allowDismiss) {
        var snap = ssGet(SNAP);
        for (var s = 0; s < snap.length; s++) {
          var key = snap[s]; var tag = key.split('|')[0];
          if (!giftPresent[key] && triggerProductInCart[tag]) ssAdd(DISMISS, key);
        }
      }
      var dismissed = ssGet(DISMISS);
      for (var d = 0; d < dismissed.length; d++) {
        var dtag = dismissed[d].split('|')[0];
        if (!triggerProductInCart[dtag]) ssRemove(DISMISS, dismissed[d]);
      }
      dismissed = ssGet(DISMISS);

      var toRemove = [];
      for (var c = 0; c < cart.items.length; c++) {
        var tag2 = cart.items[c].properties && cart.items[c].properties[TAG];
        if (tag2 && !triggerProductInCart[String(tag2)]) toRemove.push(cart.items[c].key);
      }
      var toAdd = [];
      for (var r = 0; r < rules.length; r++) {
        var t = numericPart(rules[r].trigger);
        var g = numericPart(rules[r].gift);
        if (!t || !g) continue;
        var pairKey = t + '|' + g;
        if (triggerProductInCart[t] && !giftPresent[pairKey] && dismissed.indexOf(pairKey) === -1) {
          var props = {}; props[TAG] = t;
          toAdd.push({ id: Number(g), quantity: 1, properties: props });
        }
      }

      /* Snapshot the intended post-pass gift set (kept + added), so the next
         'cart-items' pass can tell a shopper delete from a not-yet-added gift.
         Engine removals are absent from it, so they never read as deletes. */
      var finalGifts = {};
      Object.keys(giftPresent).forEach(function (k) { if (triggerProductInCart[k.split('|')[0]]) finalGifts[k] = true; });
      toAdd.forEach(function (it) { finalGifts[String(it.properties[TAG]) + '|' + String(it.id)] = true; });
      ssSet(SNAP, Object.keys(finalGifts));

      if (!toRemove.length && !toAdd.length) return;
      var chain = Promise.resolve(null);
      if (toRemove.length) chain = chain.then(function () { return removeKeys(toRemove); });
      if (toAdd.length) chain = chain.then(function (prev) { return addGifts(toAdd).then(function (added) { return added || prev; }); });
      return chain.then(function (last) {
        var html = drawerHTMLOf(last);
        if (html) paintDrawer(html);
        if (last) updateBubble(last.item_count);
      });
    }).catch(function (e) {
      console.warn('[bxgy] reconcile failed', e);
    }).then(function () {
      running = false;
      if (queued) { queued = false; var d2 = queuedDismiss; queuedDismiss = false; reconcile(null, d2); }
    });
  }

  function start() {
    if (!readRules().length) return;
    reconcile();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === 'bxgy') return;
        /* Only a shopper's own cart edit (source 'cart-items') can dismiss a gift. */
        reconcile(event && event.cartData, !!(event && event.source === 'cart-items'));
      });
    }
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
